import { Outlet, Route, Routes, useLocation } from "react-router-dom";

import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import 'primeicons/primeicons.css';
import "./App.css";
import "./grid.css";
import Loader, { IframeLoader } from "./components/SharedComponents/Loader";
import ProtectedRoute from "./utils/ProtectedRoute";
import FuelSystemLines from "./pages/FuelSystemLines/FuelSystemLines";
import { useErrorHandler } from "./services/errorhandler";
import { useDispatch, useSelector } from "react-redux";
import { AuthService } from "./services/auth.service.ts";
import { slice, UpdateToast } from "./store/slices/auth.js";
import { Toast } from "primereact/toast";
import * as Sentry from '@sentry/react';
const MainLayout = lazy(() => import("./pages/MainLayout"));
const LoginPage = lazy(() => import("./pages/Login/Login"));
const Register = lazy(() => import("./pages/Register/Register"));
const FuelSystemMapping = lazy(() => import("./pages/FuelSystemMapping/FuelSystemMapping"))
const ProductCategories = lazy(() => import("./pages/ProductCategories/ProductCategories"))
const Analytics = lazy(() => import("./pages/Analytics/Analytics"))
const Reporting = lazy(() => import("./pages/Reporting/Reporting"))
const UserProfile = lazy(() => import("./pages/UserProfile/UserProfile"))
const Admin = lazy(() => import("./pages/Admin/Admin"))
const Site = lazy(() => import("./pages/site/Site.js"))
const AccessDenied = lazy(() => import("./pages/AccessDenied.js"))
const IframeLayout = lazy(() => import("./pages/IframeLayout.jsx"))

const SuspenseLayout = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Outlet />
    </Suspense>
  );
};
const SuspenseIframLayout = () => {
  return (
    <Suspense fallback={<IframeLoader />}><Outlet /></Suspense>
  )
}
const SuspenseWrapper = ({ children }) => {
  return (
    <Suspense fallback={<Loader />}>
      {children}
    </Suspense>
  );
};
if (!window.origin.includes('local')) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    environment: process.env.REACT_APP_SENTRY_ENV || 'NoEnv',
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/inventoryvariance\.proteanapp\.com\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}
function App() {
  const toastRef = useRef(null);
  const errorHandler = useErrorHandler();
  const dispatch = useDispatch();
  const location = useLocation();
  const { loggedIn, toast, profile, isRefreshToken } = useSelector((state) => state.auth);
  const [isRefreshTokenexp, setIsRefreshTokenexp] = useState(isRefreshToken)
  const [isIframe, setIsIframe] = useState(false);
  const closeToast = (e) => {
    dispatch(UpdateToast({ severity: null, message: null }));
  }
  // useEffect(() => {
  //   if(loggedIn){
  //     AuthService.getUser().pipe(errorHandler("Get User")).subscribe((response) => {
  //       if (response?.data) {
  //         dispatch(
  //           slice.actions.profile({
  //             profile: response.data,
  //           }));
  //       }
  //     })
  //   }
  // }, [loggedIn])
  if (location.pathname.includes('/iframe')) {
    let data = location?.search?.split('&');
    let token = data.length >= 1 ? data[0].replace('?token=', '') : '';
    let client = data.length >= 2 ? data[1].replace('client=', '') : '';
    let currentTime = new Date();
    localStorage.setItem('token', token);
    localStorage.setItem('isIframe', 'true');
    localStorage.setItem('clientId', client);
    localStorage.setItem('InititalTimeStamp', currentTime.toString())
  }
  const sendHeight = () => {
    const height = calculateHeight();
    window.parent.postMessage(
      {
        type: 'IFRAME_RESIZE',
        height: height,
      },
      'https://proteanapp.com'//process.env.REACT_APP_PROTEAN_APP_URL

    );
  };

  const calculateHeight = () => {
    const rootEl = document.getElementById('root');
    const firstChild = rootEl?.children?.[0];
    let childHeight;
    if (firstChild && firstChild.getBoundingClientRect) {
      childHeight = firstChild.getBoundingClientRect().height;
    }
    if (location.pathname.includes('/iframe/reporting')) {
      return 650
    }
    return childHeight <= 500 ? childHeight + 50 : childHeight || 1250;
  };
  useEffect(() => {
    window.addEventListener('message', handleMessageFromParent);
    const resizeObserver = new ResizeObserver(sendHeight);
    resizeObserver.observe(document.body);
    setTimeout(sendHeight, 0)
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('message', handleMessageFromParent);
      localStorage.removeItem('Session');
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('access_token_expiry');
      localStorage.removeItem('Role');
      localStorage.removeItem('clientId');
      localStorage.removeItem('isIframe');
      localStorage.removeItem('InititalTimeStamp');
    };
  }, []);
  function handleMessageFromParent(event) {
    if (event.origin !== 'https://proteanapp.com') return; //process.env.REACT_APP_PROTEAN_APP_URL
    const { type, payload } = event.data || {};
    if (type === 'MESSAGE_FROM_PROTEAN' && payload) {
      try {
        const response = JSON.parse(payload.login_data);
        const decodedAccessToken = decodeToken(response?.access_token);
        const role = response?.roles[0]?.role_name
        const clientId = response?.client_id
        if (role) {
          isManager = role?.toLocaleLowerCase() === "manager" ? true : false;
        }
        dispatch(
          slice.actions.logIn({
            token: response?.access_token,
            refreshToken: response?.refresh_token,
            accessTokenExpiry: decodedAccessToken?.exp * 1000,
            loggedIn: true,
            isRefreshToken: true,
            role,
            clientId
          }));
        setIsIframe(true);
      } catch (error) {
        console.error('Error parsing message payload:', error);
      }
    }
  };


  useEffect(() => {
    toast?.current?.clear();
    toastRef.current?.show({
      severity: toast.severity,
      detail: toast.message,
      life: 2000,
    });

    return () => {
      toast.current?.clear();
    };
  }, [toast]);


  const decodeToken = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("Failed to decode token", error);
      return null;
    }
  }
  const checkAndRefreshToken = (validationsData) => {
    const { accessToken, refreshToken, tokenExpiry, role, clientId } = validationsData;
    if (refreshToken) {
      let _body = { "refresh_token": refreshToken };

      try {
        AuthService.getRefreshToken(_body).subscribe(
          (res) => {
            const { data } = res;
            const decodedToken = decodeToken(data.access_token);
            const newExpiry = decodedToken?.exp * 1000;
            localStorage.setItem("token", data.access_token);
            localStorage.setItem("access_token_expiry", newExpiry);
            setIsRefreshTokenexp(true)
            dispatch(
              slice.actions.logIn({
                token: data.access_token,
                refreshToken: null,
                loggedIn: true,
                accessTokenExpiry: newExpiry,
                isRefreshToken: true,
                role,
                clientId
              })
            );
          },
          (error) => {
            console.log(error);
            if (!isIframe) {
              dispatch(slice.actions.logout())
            }
          }
        );
      } catch (error) {
        console.log(error);
        if (!isIframe) {
          dispatch(slice.actions.logout())
        }
      }
    }
  };

  useEffect(() => {
    let timeoutId;
    const checkTokenExpiry = () => {
      const currentPath = location.pathname;
      const refreshToken = localStorage.getItem("refresh_token");
      const tokenExpiry = parseInt(localStorage.getItem("access_token_expiry"), 10);
      const accessToken = localStorage.getItem("token");
      const role = localStorage.getItem("Role")
      const clientId = localStorage.getItem("clientId")

      if (tokenExpiry && Date.now() >= tokenExpiry) {
        if (currentPath !== '/login') {
          checkAndRefreshToken({ accessToken, refreshToken, tokenExpiry, role, clientId });
        }
      } else {
        const timeLeft = tokenExpiry - Date.now();
        if (timeLeft > 0) {
          timeoutId = setTimeout(() => {
            checkTokenExpiry();
          }, Math.max(timeLeft - 5000, 0));
        }
      }
      if (!(localStorage.getItem("token")) && currentPath !== '/login') {
        if (!isIframe) {
          dispatch(slice.actions.logout())
        }
      }
    };
    checkTokenExpiry();
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [location.pathname, isRefreshTokenexp]);
  let isManager = false;
  if (localStorage.getItem("token")) {
    isManager = localStorage.getItem("Role")?.toLocaleLowerCase() === "manager" ? true : false;
  }

  const STATUS_CODES = [403, 404];

  return (
    <>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<SuspenseWrapper> <MainLayout /> </SuspenseWrapper>} >
            <Route path={"/"} element={<SuspenseLayout />}>
              <Route path={"/"} element={isManager ? <FuelSystemLines /> : <Admin />} />
              <Route path={"/fuel-system-mapping"} element={isManager ? <AccessDenied statusCode={STATUS_CODES[0]} /> : <FuelSystemMapping />} />
              <Route path={"/product-categories"} element={isManager ? <AccessDenied statusCode={STATUS_CODES[0]} /> : <ProductCategories />} />
              <Route path={"/fuel-system-lines"} element={<FuelSystemLines />} />
              <Route path={"/reporting"} element={<Reporting />} />
              <Route path={"/analytics"} element={<Analytics />} />
              <Route path={"/user-profile"} element={<UserProfile />} />
              <Route path={"/admin"} element={isManager ? <AccessDenied statusCode={STATUS_CODES[0]} /> : <Admin />} />
              <Route path="/site" element={isManager ? <AccessDenied statusCode={STATUS_CODES[0]} /> : <Site />} />
              <Route path="*" element={<AccessDenied statusCode={STATUS_CODES[1]} />} />
            </Route>
          </Route>
        </Route>
        <Route path={"/"} element={<SuspenseIframLayout />}>
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<Register />} />
          <Route path='iframe' element={<IframeLayout />}>
            <Route path={"fuel-system-mapping"} element={isManager ? <AccessDenied statusCode={STATUS_CODES[0]} /> : <FuelSystemMapping />} />
            <Route path={"product-categories"} element={isManager ? <AccessDenied statusCode={STATUS_CODES[0]} /> : <ProductCategories />} />
            <Route path={"fuel-system-lines"} element={<FuelSystemLines />} />
            <Route path={"reporting"} element={<Reporting />} />
            <Route path={"analytics"} element={<Analytics />} />
            <Route path={"user-profile"} element={<UserProfile />} />
            <Route path={"admin"} element={isManager ? <AccessDenied statusCode={STATUS_CODES[0]} /> : <Admin />} />
            <Route path="site" element={isManager ? <AccessDenied statusCode={STATUS_CODES[0]} /> : <Site />} />
            <Route path="*" element={<AccessDenied statusCode={STATUS_CODES[1]} />} />
          </Route>
        </Route>
        <Route path="*" element={<AccessDenied statusCode={STATUS_CODES[1]} />} />
      </Routes>
      {toast?.message && (
        <Toast className="p-5 mb-5" onHide={closeToast} ref={toastRef} />
      )}
    </>
  );
}
export default App;
